import { isolateComponent } from '@zapier/style-encapsulation';
import { Alert } from '@zapier/design-system';
const parsedTime = Date.now();
export const shouldRender = () => {
    const hoursElapsed = (Date.now() - parsedTime) / 1000 / 60 / 60;
    return hoursElapsed > 24;
};
export const Component = function RefreshRequired() {
    return (isolateComponent(Alert, { ariaLive: "polite", layout: "banner", title: "A new version of Zapier is available", type: "info" },
        isolateComponent("p", null,
            isolateComponent("button", { type: "button", css: { textDecoration: 'underline' }, onClick: () => window.location.reload() }, "Refresh now"),
            ' ',
            "to get the latest version")));
};
//# sourceMappingURL=RefreshRequired.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
